<template>
  <div id="app">
    <component :is="layout">
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </component>
    <simplert use-radius use-icon ref="simplert" /><!-- notifs -->
    <div v-if="env !== 'production'" id="env">{{this.env}} - {{ configComplete }} - {{ ecosystem.product }} - ({{ toConfig }}/{{ configured }})</div><!-- env -->
    <span id="powered-by" v-if="ecosystem.showPoweredBy">Powered by <a href="https://moova.io" target="_blank">Moova</a></span><!-- powered by -->
    <spinner />
    <front-version-checker />
    <div class="bg-white" style="position: fixed; top: 0; right: 0; bottom: 0; left: 0; z-index: 1051" v-if="!configComplete">
      <div class="container h-100 d-flex justify-content-center">
        <b-progress :value="configured" :max="toConfig" class="col-8 col-md-4 px-0 my-auto"></b-progress>
     </div>
    </div>
  </div>
</template>

<script>
const defaultLayout = 'default'

import ModelsMixin from '@/common/models'
import DataTransformersMixin from '@/common/dataTransformers'
// import QuickFiltersMixin from '@/common/quickFilters'
import simplert from 'vue2-simplert'
import Spinner from '@/components/Spinner'
import FrontVersionChecker from '@/components/FrontVersionChecker'

export default {
  name: 'App',
  components: {
    simplert,
    Spinner,
    FrontVersionChecker
  },
  data() {
    return {
      env: process.env.ENV_FLAG
    }
  },
  watch: {
    '$language.current': {
      handler(val) {
        this.setModels()
        this.setQuickFilters()
      },
      deep: true
    }
  },
  computed: {
    layout() {
      return (this.$route.meta.layout || defaultLayout) + '-layout'
    }
  },
  mixins: [
    ModelsMixin,
    DataTransformersMixin
    // QuickFiltersMixin
  ],
  created() {
    // i18n setup
    if (this.frontConfig) {
      let moment = this.frontConfig.i18n.moment || 'en'
      this.moment.locale(moment)
      this.moment.tz.setDefault(this.$tz)
      window.moment.locale(moment)
      window.moment.tz.setDefault(this.$tz)
    } else {
      window.country = null
    }

    // Dynamic favicon
    let link = document.querySelector("link[rel*='icon']") || document.createElement('link')
    link.type = 'image/png'
    link.rel = 'shortcut icon'
    link.href = '/static/img/dashboard-icon' + (process.env.NODE_ENV !== 'production' ? '-development' : '') + '.png'
    document.getElementsByTagName('head')[0].appendChild(link)
  },
  mounted() {
    this.setup()
    console.log(this.ecosystem)
    document.documentElement.style.setProperty(
      '--primary',
      '#990000'
    )
    console.log(document.documentElement.style)
  },
  methods: {
    logout() {
      this.$http.post(this.$appConfig.api.baseUrl + 'logout')
        .then(() => {
          this.$store.dispatch('logout').then(() => {
            window.location.href = window.location.origin
          })
        })
    },
    setNewCountry() {
      if (window.country !== null) {
        this.$frontConfig = window.countries.find(x => x.iso_code === window.country).front_config || null
        this.$cookies.set('country', window.country, 60 * 60 * 24 * 30, null, null, (process.env.COOKIE_SECURE !== '' || false), process.env.COOKIE_SAME_SITE)
        this.$cookies.set('phonePrefix', this.$frontConfig.i18n.phonePrefix, 60 * 60 * 24 * 30, null, null, (process.env.COOKIE_SECURE !== '' || false), process.env.COOKIE_SAME_SITE)
        this.$emit('countryChanged')
      }
      window.location.reload()
    }
  }
}

</script>
<style lang="scss">
.moova {
  @import 'assets/scss/moova.scss';
}

.page-header {
  height: auto !important;
}

.simplert {
  z-index: 10060 !important;
}

#env {
  position: fixed;
  top: 0;
  left: 0;
  background: #000;
  color: #fff;
  padding: 2px 5px;
  z-index: 10000
}

#cant-operate {
  position: fixed;
  top: 0;
  left: 0;
  background: #fff;
  width: 100%;
  height: 100%;
  z-index: 9999;
  overflow-y: auto;
}

/* for T&C dropdown link height */
.navbar .dropdown-menu .small .dropdown-item {
  padding: .35rem 1.5rem;
}

/* 2FA PINcode */
div.vue-pincode-input-wrapper {
  font-size: 1.6rem;
}
input.vue-pincode-input {
  box-shadow: 0 0 15px rgba(0,0,0,.1);
  max-width: 3rem !important;
  margin: .25rem !important;
  background: #fff;
  border: 1px solid #ddd;
  transition: all .25s ease-in-out;
  &:focus {
    border: 1px solid #ccc;
    box-shadow: 0 0 5px rgba(0,0,0,.25);
  }
}
</style>
